// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from '../../components/CRUD/EditEntity';
import { log } from 'console';

const UpdateOrganisationBank = () => {
  return (
    <EditEntity
      pageTitle="EditOrganisationBank"
      fetchApiUrl="/api/v1/web_portal/settlements/organisation-banks/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      inputs={[
        {
          name: 'bank_name',
          labelKey: 'BankName',
          inputType: 'text',
          required: false,
          disabled: true,
          useLanguageValue: true,
          enKey: 'bank_name_en',
          arKey: 'bank_name_ar',
        },
        {
          name: 'organisation_name',
          labelKey: 'Organisation',
          inputType: 'text',
          required: false,
          disabled: true,
          useLanguageValue: true,
          enKey: 'organisation_name_en',
          arKey: 'organisation_name_ar',
        },
        {
          name: 'organisation_id',
          inputType: 'hidden',
        },
        {
          name: 'account_name',
          labelKey: 'AccountName',
          inputType: 'text',
          required: true,
        },
        {
          name: 'account_number',
          labelKey: 'AccountNumber',
          inputType: 'text',
          required: true,
        },
        {
          name: 'iban',
          labelKey: 'IBAN',
          inputType: 'text',
          required: true,
        },
        {
          name: 'branch_name',
          labelKey: 'BranchName',
          inputType: 'text',
          required: false,
        },
        {
          name: 'branch_address',
          labelKey: 'BranchAddress',
          inputType: 'text',
          required: false,
        },
        {
          name: 'beneficiary_email',
          labelKey: 'BeneficiaryEmail',
          inputType: 'email',
          required: false,
        },
        {
          name: 'beneficiary_mobile',
          labelKey: 'BeneficiaryMobile',
          inputType: 'text',
          required: false,
        },
      ]}
      additionalApis={[
        {
          name: 'organisation',
          url: (mainData) => `/api/v1/organisations/${mainData.organisation_id}`,
          method: 'GET',
          dataPath: 'data',
          onSuccess: (orgData, mainData) => {
   
            mainData.organisation_name_en = orgData.data.en_name;
            mainData.organisation_name_ar = orgData.data.ar_name;
          },
        },
      ]}
      dropdowns={[
        {
          name: 'financial_account_id',
          labelKey: 'FinancialAccount',
          required: true,
          dependsOn: 'organisation_id',
          apiUrl: (formValues) => 
            `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts/org/${formValues.organisation_id}`,
          apiMethod: 'GET',
          dataPath: 'data.data.financialAccounts',
          optionConfig: {
            valueKey: 'id',
            labelKey: 'name',
            labelKeyAr: 'name',
          },
        },
      ]}
      updateApiUrl="/api/v1/web_portal/settlements/organisation-banks/:id"
      updateApiMethod="PATCH"
      buildUpdatePayload={(formValues, params, entityData) => {
        return {
          account_name: formValues.account_name?.trim(),
          account_number: formValues.account_number?.trim(),
          iban: formValues.iban?.trim(),
          branch_name: formValues.branch_name?.trim() || null,
          branch_address: formValues.branch_address?.trim() || null,
          beneficiary_email: formValues.beneficiary_email?.trim() || null,
          beneficiary_mobile: formValues.beneficiary_mobile?.trim() || null,
          financial_account_id: formValues.financial_account_id,
        };
      }}
      backUrl="/settlements/OrganisationBanks/:id"
      successMessage="UpdatedSuccessfully"
      updateButtonLabel="update"
    />
  );
};

export default UpdateOrganisationBank;
